export const ROLES = {
  GUEST: 'guest',
  USER: 'user',
  REPRESENTANTE: 'representante',
  ADMIN: 'admin',
};
